import { Action } from "../action";
import { createReducer } from "../createReducer";
import { fetchCloudImageTiers } from "../../utils/cloudImageTiers";
import type { CloudImageTiers } from "../../utils/cloudImage";
import type { ThunkResult } from "../store";

export interface CloudImageTiersState {
  tiers: CloudImageTiers;
}

/*************  Actions  ****************/

const ActionTypes = {
  SET_CLOUD_IMAGE_TIERS: "CLOUD_IMAGE_TIERS/SET_CLOUD_IMAGE_TIERS",
};

const ActionCreators = {
  setCloudImageTiers: (tiers: CloudImageTiers): Action<CloudImageTiers> => ({
    type: ActionTypes.SET_CLOUD_IMAGE_TIERS,
    payload: tiers,
  }),
};

/*************  Side Effects  ****************/

const ThunkActionCreators = {
  // Load the Cloudimage resolution tiers from the configuration tool ("global" config) into the
  // store. On any failure the slice keeps its (empty) state and getCloudImageUrl uses defaults.
  loadCloudImageTiers: (): ThunkResult<Promise<void>> => async (dispatch) => {
    const tiers = await fetchCloudImageTiers();
    if (tiers) {
      dispatch(ActionCreators.setCloudImageTiers(tiers));
    }
  },
};

/*************  Reducer  ****************/

const initialState: CloudImageTiersState = { tiers: {} };

const Reduction = {
  setCloudImageTiers: (
    _state: CloudImageTiersState,
    { payload: tiers }: Action<CloudImageTiers>
  ): CloudImageTiersState => ({ tiers }),
};

const reducer = createReducer(initialState, {
  [ActionTypes.SET_CLOUD_IMAGE_TIERS]: Reduction.setCloudImageTiers,
});

export default reducer;

export {
  reducer as CloudImageTiersReducer,
  ActionTypes as CloudImageTiersActionTypes,
  ActionCreators as CloudImageTiersActions,
  ThunkActionCreators as CloudImageTiersThunks,
};
